/**
 * @license Siftrock
 * (c) 2014-2018 Siftrock, Inc. http://siftrock.com
 * Unauthorized copying of this file, via any medium is strictly prohibited
 */

import { Injectable, EventEmitter } from '@angular/core';

@Injectable()
export class EventService {
  loggedIn$: EventEmitter<boolean>;
  versionChange$: EventEmitter<string>;
  toggleAllWorkflowDetails$: EventEmitter<boolean>;
  toggleAllCdoSyncDetails$: EventEmitter<boolean>;
  classifyTest$: EventEmitter<any>;

  constructor() {
    this.loggedIn$ = new EventEmitter();
    this.versionChange$ = new EventEmitter();
    this.toggleAllWorkflowDetails$ = new EventEmitter();
    this.toggleAllCdoSyncDetails$ = new EventEmitter();
    this.classifyTest$ = new EventEmitter();
   }

}



// WEBPACK FOOTER //
// ./client/app/services/event.service.ts